import { FormLoader } from "./form-loader.js"
import {registerLicense} from '@syncfusion/ej2-base';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1feHVURmBeVUFxWUA=');

document.addEventListener("DOMContentLoaded", () => {
    const forms = document.querySelectorAll("tiberform");

    if ((forms?.length ?? 0) === 0) {
        console.error("Tiber Forms module loaded; however, No forms found");
        return;
    }

    FormLoader.loadForms(forms)
        .then(_ => console.debug("Tiber Forms module loaded"))
        .catch(error => {
            console.error("Tiber Forms module failed to load");
            console.error(error);
        });
})
